import { useNavigate } from "react-router-dom";
import HeaderComponent from "../../components/header";
import ContainerComponent from "../../components/conatiner";
import CardHeaderBackgroundComponent from "../../components/cardHeaderBackground";
import InputComponent from "../../components/input";
import { ChangeEvent, useEffect, useState } from "react";
import TableComponent from "../../components/table";
import { UserDeleteService, UsersService } from "../../services/users";
import { ToastErro, ToastSucesso } from "../../components/toast";
import { IUser } from "../../types";
import ModalComponent from "../../components/modal";

const UsersPage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(true);

    // variaveis de pesquisa
    const [name, setName] = useState<string>('');
    const [page, setPage] = useState<number>(1);
    // variaveis de pesquisa

    const [users, setUsers] = useState<any>([]);

    // funcao para pesquisar usuários
    const getUsers = async () => {

        setLoading(true);

        await UsersService(name, page).then(resp => {
            setUsers(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // funcao para pesquisar usuários

    // função para desativar/ativar usuário
    const deleteUser = async (id: number) => {

        (window as any).$("#modalDelete" + id).modal('hide');

        setLoading(true);

        await UserDeleteService(id).then(resp => {
            ToastSucesso(resp.data.message);
            getUsers();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        });

    }
    // função para desativar/ativar usuário

    useEffect(() => {
        getUsers();
    }, [page]);

    return (
        <>
            <HeaderComponent
                title="Usuários"
                button="Usuário"
                iconButton="add"
                onClick={() => navigate('/users/create')}
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        <>
                            <div className="row">
                                <InputComponent
                                    label="Nome"
                                    col={8}
                                    size={"small"}
                                    defaultValue={name}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                                />
                                <div className="col-md-4">
                                    <button className="btn btn-primary" type="button" onClick={() => page > 1 ? setPage(1) : getUsers()}>Pesquisar</button>
                                    <button className="btn btn-danger" type="button" style={{ marginLeft: 15 }} onClick={() => (window as any).location.reload()}>Limpar</button>
                                </div>
                            </div>
                        </>
                    </CardHeaderBackgroundComponent>

                    <TableComponent
                        title="Usuários"
                        columns={['ID', 'Nome', 'Username', 'E-mail', 'Ativo', 'Ações']}
                        loading={loading}
                        last_page={users?.last_page}
                        page={page}
                        onClickPagination={(e: ChangeEvent<unknown>, value: number) => setPage(value)}
                    >
                        {
                            users?.data?.map((u: IUser) => {
                                return (
                                    <tr key={u.id}>
                                        <td className="px-4">{u.id}</td>
                                        <td className="px-4">{u.name}</td>
                                        <td className="px-4">{u.username}</td>
                                        <td className="px-4">{u.email}</td>
                                        <td className="px-4">
                                            {
                                                u.active == 1

                                                    ?

                                                    <h5><span className="badge bg-success">Sim</span></h5>

                                                    :

                                                    <h5><span className="badge bg-danger">Não</span></h5>
                                            }
                                        </td>
                                        <td>
                                            <button className="btn btn-text-warning" type="button" title="Editar" onClick={() => navigate(`/users/${u.id}`)}><i className="material-icons">edit</i></button>
                                            <button className="btn btn-text-danger" type="button" title={`${u.active === 1 ? 'Desativar' : 'Ativar'}`} onClick={() => (window as any).$("#modalDelete" + u.id).modal('show')}><i className="material-icons">{u.active === 1 ? 'delete' : 'upload'}</i></button>
                                            <ModalComponent
                                                title={u.active == 1 ? 'Desativar Usuário' : 'Ativar Usuário'}
                                                id={`modalDelete${u.id}`}
                                            >
                                                <>
                                                    <p>Você tem certeza que deseja {u.active == 1 ? 'desativar' : 'ativar'} o usuário abaixo?</p>

                                                    <table className="table">
                                                        <tbody>
                                                            <tr>
                                                                <td>ID:</td>
                                                                <td>{u.id}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Nome:</td>
                                                                <td>{u.name}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Usuário:</td>
                                                                <td>{u.username}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>E-mail:</td>
                                                                <td>{u.email}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <div className="d-flex justify-content-end mt-4">
                                                        <button className="btn btn-primary" type="button" onClick={() => deleteUser(u.id)}>{u.active == 1 ? 'Desativar' : 'Ativar'}</button>
                                                    </div>
                                                </>
                                            </ModalComponent>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>
                </>
            </ContainerComponent>
        </>
    );

}

export default UsersPage;